import { Injectable } from '@angular/core';
import L from '../leaflet-plugins-loader';
import { LeafletService } from '../leaflet.service'
import { INgsiMapBaseEntity } from '../../ngsild/interfaces/ngsi-entity.interface'
import { IMapWidgetFormGroupSettings } from '../../../map-widget-settings/map-widget-settings.interface'
import { ILeafletInstance } from '../leaflet.interface'
import { getAISCustomTrackPopupContent, TrackerDetails } from '../markers/leaflet-tracksymbol2/ais-track-symbol'
import { INgsiAIS } from '../../ngsild/interfaces/ngsi-ais.interface'
import * as NgsiMaritimeTargets from '../../ngsild/models/ngsi-maritime-targets'
import * as NgsiRadarTargets from '../../ngsild/models/ngsi-radar-target'
import * as NgsiFusionMaritimeTarget from '../../ngsild/models/ngsi-fusion-maritime-target'
import * as leafletInstanceConfig from '../../ngsild/helpers/leaflet-instance-config.constants'

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  constructor(private readonly leafletService: LeafletService) {}

  getCirclePopup(circle: L.Circle<any>): ReturnType<typeof L.responsivePopup> {
    let popup = circle.getPopup();
    if (!popup) {
      popup = this._createPopup();
    }

    return popup;
  }


  bindPopupOnce(
      marker: L.Marker<any>,
      entity: any,
      settings: IMapWidgetFormGroupSettings,
      instance: ILeafletInstance,
      popupService: PopupService,
      trackerDetails: TrackerDetails
  ) {
    if (!marker || (marker as any)._popupInitialized) {
      return
    }
    (marker as any)._popupInitialized = true

    const responsivePopup = L.responsivePopup({
      hasTip: true,
      autoPan: false,
      offset: [10, 10],
      className: 'custom-responsive-popup',
      keepInView: true,
      closeOnClick: true,
      closeButton: true,
      autoClose: true,
      interactive: true
    });

    marker.bindPopup(responsivePopup)

    marker.on('popupopen', () => {
      const popupContent = popupService.getPopupContent(
          entity,
          settings,
          instance,
          trackerDetails
      )

      if (!popupContent) {
        return
      }

      const popup = marker.getPopup()
      if (!popup) {
        return
      }

      const currentContent = popup.getContent()
      let currentHTML = ''
      if (typeof currentContent === 'string') {
        currentHTML = currentContent
      } else if (currentContent instanceof HTMLElement) {
        currentHTML = currentContent.innerHTML
      }
      if (currentHTML !== popupContent.innerHTML) {
        popup.setContent(popupContent)
      }
    })
  }

  getPopupContent(
      entity: INgsiMapBaseEntity,
      settings: IMapWidgetFormGroupSettings,
      instance: ILeafletInstance,
      trackerDetails?: TrackerDetails
  ): HTMLElement | undefined {
    return this.getPopupByEntityType(entity, settings, instance, trackerDetails);
  }

  private getPopupByEntityType(
      entity: INgsiMapBaseEntity,
      settings: IMapWidgetFormGroupSettings,
      instance: ILeafletInstance,
      trackerDetails?: TrackerDetails
  ): undefined | HTMLElement {
    if (!trackerDetails?.marker || !trackerDetails?.positionReport || !trackerDetails?.options) {
      return undefined;
    }

    const { positionReport, options } = trackerDetails;
    const { translator } = this.leafletService;

    switch (entity.type) {
      case leafletInstanceConfig.config.dataSourceSelector.MMSI.value.type:
      case NgsiMaritimeTargets.entityType:
      case NgsiRadarTargets.entityType:
      case NgsiFusionMaritimeTarget.entityType:
        // Popup-Inhalt (DOM-Element) wird nur hier einmalig beim Öffnen erzeugt
        return getAISCustomTrackPopupContent(entity as INgsiAIS, translator, positionReport, options.shipStaticData);

      default:
        return undefined;
    }
  }

  private _createPopup(): ReturnType<typeof L.responsivePopup> {
    return L.responsivePopup({
      hasTip: true,
      autoPan: false,
      offset: [15, 20],
      className: "osm-map-popup",
      keepInView: true,
      closeOnClick: true,
      closeButton: true,
      autoClose: true,
      interactive: true
    });
  }
}
